import React from 'react';

function normalizeSectionTitle(title) {
  return String(title || '').replace(/^\s{0,3}#{1,6}\s*/, '').trim();
}

function getStatusMeta(value) {
  const text = String(value || '').trim();
  const normalized = text.toLowerCase();

  if (normalized.includes('priority')) {
    return { tone: 'priority', label: text };
  }
  if (normalized.includes('included')) {
    if (normalized.includes('not included')) {
      return { tone: 'none', label: text };
    }
    return { tone: 'included', label: text };
  }
  if (normalized.includes('limited')) {
    return { tone: 'limited', label: text };
  }

  return { tone: 'neutral', label: text };
}

function BenefitsComparison({ title, rows, memberships }) {
  return (
    <section className="career-comparison" aria-labelledby="career-comparison-title">
      <div className="wrap">
        <div className="career-comparison__head head-block">
          <p className="eyebrow">Plan Clarity</p>
          <h2 id="career-comparison-title" className="section-title">{normalizeSectionTitle(title)}</h2>
          <p className="section-sub">Compare what each membership unlocks so you can choose the right next step for your current career stage.</p>
        </div>
        <div className="career-comparison__table-wrap">
          <table>
            <thead>
              <tr>
                <th>Benefit</th>
                {memberships.map((membership) => (
                  <th key={membership.id}>{membership.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.label}>
                  <td className="career-comparison__benefit">{row.label}</td>
                  {memberships.map((membership) => {
                    const status = getStatusMeta(row.values[membership.id]);

                    return (
                      <td key={`${membership.id}-${row.label}`}>
                        <span className={`career-comparison__status is-${status.tone}`}>{status.label}</span>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

export default BenefitsComparison;